<template>
<div id="pedv">
    <bar-manut 
        single-entity="Pagamento" 
        plural-entity="Pagamentos" 
        :crud="this.crud"
        :btn-delete="false"
        @closeform="closeForm" 
        @save="handleSave">
    </bar-manut>
    <div class="default-container">
        <div class="row">
            <form-field v-model="pedv.codpedv" type="text" col="2" :disabled="true"></form-field>
        </div>    
        <div class="row">    
            <form-field ref="nome" v-model="cartao.nome" type="text" col="6" label="Nome" 
                name="nome" :v-errors="errors" ></form-field>
        </div>    
        <div class="row">    
            <form-field v-model="cartao.numero" type="number" col="6" label="Numero"  
                name="numero" :v-errors="errors" ></form-field>
        </div>    
        <div class="row">    
            <form-field v-model="cartao.valmes" type="number" col="2" label="Validade: Mes"  
                name="valmes" :v-errors="errors" ></form-field>
            <form-field v-model="cartao.valano" type="number" col="2" label="Ano" 
                name="valano" :v-errors="errors" ></form-field>
        </div>    
        <div class="row">    
            <form-field v-model="cartao.codsec" type="number" col="3" label="CVV" 
                name="codsec" :v-errors="errors" ></form-field>
        </div>
    </div>
    </br>
    <div class="default-container">


          <div class="row my-3">
            <h6>Produtos</h6>
          </div>

          <div class="row border bg-white py-3 mb-2" v-for="(item, index) in pedvit" :key="index">
          
            
            <div class="col-md-6 col-6">
              <img v-if="item.item[0].url != '' " class="d-inline-block" style="max-width: 45px" :src="item.item[0].url" >
              <span class="card-text d-inline-block" style="max-width: 70%"> {{ item.item[0].descricao }} </span>
              <p class="mt-2">
                  <em v-if="item.ptotdes > 0" class="desconto detail">{{ item.ptotdes | formatValue(0) }}% OFF</em>
                  <em v-if="item.totdes > 0" class="">Economia de R${{ item.totdes | formatValue(2) }}</em>
              </p>
            </div>
          
            <div class="col-auto">
                <span class="card-label">Quantidade</span><br>
                <em class=""> {{ item.qt }}</em>
            </div>
            <div class="col-auto">
                <span class="card-label">Preço Unitário</span><br>
                <em v-if="item.totbru > 0" class="valor-de" style="display: inline-block;">De: <strong>R$ {{ item.totbru | formatValue(2) }}</strong></em>
                <em v-if="item.totbru > 0" class="">por <strong>R${{ item.vlr | formatValue(2) }}</strong>/{{ item.uni }}</em>
            </div>
            <div class="col-auto">
                <span class="card-label">Preço Total</span><br>
                <em class=""><strong>R${{ item.totliq | formatValue(2) }}</strong></em>
            </div>
<!--            
            <div class="col-md-12" v-if="produto.grade.length > 0">
              <div class="w-100 d-flex mb-2" v-for="(item, index) in produto.grade" :key="index">
                <span style="width: 100px" v-if="item.linha"> {{ item.linha }} </span>
                <span style="width: 100px" v-if="item.coluna"> {{ item.coluna }} </span>
                <span style="width: 100px"> Qt: {{ item.quantidade }} </span>
              </div>
            </div>
-->          
          </div>

          <div class="row my-3">
            <h6>Totais</h6>
          </div>
          <div class="row border bg-white p-3">
            <div class="col-3 mb-3">
              <span class="card-label d-block"> Quantidade de Produtos </span>
              <span class="card-text"> {{ pedvit.length }} </span>
            </div>
          
            <hr>
            <div class="col-3 text-right mb-3">
              <span class="card-label d-block"> SubTotal </span>
              <span class="card-text"> {{ pedv.totmer | formatValue(2) }} </span>
            </div>
            <div class="col-3 text-right mb-3">
              <span class="card-label d-block"> Descontos </span>
              <span class="card-text"> {{ pedv.totdes | formatValue(2) }} </span>
            </div>
            <div class="col-3 text-right">
              <span class="card-label d-block"> Total Geral </span>
              <span class="card-text"> <strong> {{ pedv.totger | formatValue(2) }} </strong> </span>
            </div>
          </div>
    </div>      


</div>

</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { lojaORDSpost, apiORDSapp } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: ''
    },

    data() {
        return {
            crudText: '',

            idempresa: '',

            pedv: {...this.$store.getters.getEntities.pedv},
            cartao: {nome: null,
                numero: null,
                valmes: null,
                valano: null,
                codsec: null
                },
            pedvit: {},
            pedvpar: [],  //parcelas do pedido
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: {},  //armazena as mensagens de validacao do pedido de venda apos a gravacao

        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            if (this.$route.params && this.$route.params.codnegocio)
               this.$router.go(-1)
            else 
            if (this.$route.params && this.$route.params.id)
               this.$router.push('/pedidolist')
            else 
               this.$emit('closeform')
        },


        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost(this.idempresa)
                }
            })
        },

        async loadData () {
            this.crud = SysVars.crudI

            
            if (this.$route.params) {
                if (this.$route.params.id && this.$route.params.id != 'novo') {
                    this.index = this.$route.params.id
                }
                if (this.$route.params.idempresa) {
                    this.idempresa = this.$route.params.idempresa;
                }
            }


            //carrega o registro para alteracao ou visualizacao
            this.unwatch = true
            
            const data = await apiORDSapp(this, 'pedv/'+this.index+'/'+this.idempresa, 'get')
            if (data.items) {
                console.log(data.items[0]);
                this.pedv = {...data.items[0]}
                this.pedvit = this.pedv.pedvit

                console.log(this.pedv);

                this.cartao = {nome: null,
                numero: null,
                valmes: null,
                valano: null,
                codsec: null
                }
                if (this.pedv.validation)
                    this.errmessages = JSON.parse(this.pedv.validation)
                if (this.pedv.pedvpar) {
                  this.pedvpar = this.pedv.pedvpar
                }

                this.updateActions() //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
                this.unwatch = false
            })


        },

        async apiPost (idempresa) {
            //efetua a gravacao

            var modulo = 'pagamentorede/'+this.idempresa;

            var sendData = {}

            sendData = { pedv: this.pedv, cartao: this.cartao }

            let metodo = 'post'
            const data = await lojaORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
                this.errmessages = data.errmessages
                this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {


    },

    created () {
        this.crudText = this.$crudText(this.crud)

        this.loadData()  

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.nome.focus()
        })
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-fv/fv-pedido-form-pag.vue